import { useState } from 'react';

// go2rtc's own page, reverse-proxied under a real HTTPS hostname/cert so it
// loads same-scheme as this app (avoids the mixed-content block a direct
// http://192.168.1.229 embed hit) -- still only reachable for whoever the
// reverse proxy allows in (LAN/VPN presumably).
//
// Streams don't connect (and start eating bandwidth) until someone actually
// clicks to load them -- with everyone in the office loading the homepage on
// a single 1Gb link, auto-connecting every camera for every page load adds
// up fast for no benefit if nobody's actually watching.
//
// `wide` drops the 640px cap, for a multi-camera wall (go2rtc's stream.html
// with several src= params) where each feed would otherwise be a thumbnail.
export default function CameraStreamWidget({ url, label, wide = false, children }) {
  const [playing, setPlaying] = useState(false);
  const widthCls = wide ? '' : 'max-w-[640px]';

  return (
    <div className="card p-4">
      <h2 className="mb-3 text-sm font-bold uppercase tracking-wide text-steel">{label}</h2>
      {children}
      {playing ? (
        <iframe
          src={url}
          loading="lazy"
          title={`${label} live stream`}
          allow="autoplay; picture-in-picture"
          scrolling="no"
          className={`mx-auto block w-full ${widthCls}`}
          style={{ aspectRatio: '640 / 360', border: 0 }}
        />
      ) : (
        <button
          onClick={() => setPlaying(true)}
          className={`mx-auto flex w-full ${widthCls} flex-col items-center justify-center gap-2 rounded-lg bg-charcoal text-white transition hover:bg-charcoal/90`}
          style={{ aspectRatio: '640 / 360' }}
        >
          <span className="text-3xl">▶</span>
          <span className="text-sm font-medium">Load {label}</span>
        </button>
      )}
    </div>
  );
}
